export function openVConsole() {
  // 加载 vconsole js
  const vconsoleScript = document.createElement('script');
  vconsoleScript.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';
  vconsoleScript.async = true;
  document.head.appendChild(vconsoleScript);

  // 连续点击十次页面某地方 出现 vConsole 调试工具
  let clickCount = 0;
  let lastClickTime = 0;
  const clickThreshold = 10; // 需要连续点击的次数
  const timeThreshold = 2000; // 点击时间间隔阈值（毫秒）
  let tipElement: HTMLDivElement | null = null;

  document.addEventListener('click', e => {
    const now = Date.now();

    // 检查是否在时间阈值内点击（模拟连续点击）
    if (now - lastClickTime > timeThreshold) {
      clickCount = 1; // 超过时间阈值，重置计数
    } else {
      clickCount++;
    }

    lastClickTime = now;

    // 显示点击次数提示
    if (clickCount < clickThreshold) {
      // 创建或更新提示元素
      if (!tipElement) {
        tipElement = document.createElement('div');
        document.body.appendChild(tipElement);
      }

      tipElement.textContent = `再点击 ${clickThreshold - clickCount} 次开启调试工具`;

      // 3秒后移除提示
      setTimeout(() => {
        if (tipElement && document.body.contains(tipElement)) {
          document.body.removeChild(tipElement);
          tipElement = null;
        }
      }, 3000);
    } else if (clickCount === clickThreshold && !window.vConsole) {
      // 达到点击次数阈值且vConsole尚未创建
      try {
        const vConsole = new window.VConsole();
        // window.vConsole = vConsole;

        // 显示开启成功提示
        if (tipElement) {
          tipElement.textContent = '调试工具已开启';
          setTimeout(() => {
            if (tipElement && document.body.contains(tipElement)) {
              document.body.removeChild(tipElement);
              tipElement = null;
            }
          }, 2000);
        }
      } catch (error) {
        console.error('Failed to initialize vConsole:', error);
      }
    }
  });
}
